export default {
    base: {
        state: 'system.settingcenter.portSetUp',
        config: {
            url: '/portSetUp',
            abstract: true,
            template: '<div ui-view></div>',
            default: 'system.settingcenter.portSetUp.list',
            title: '接口配置',
        },
    },
    list: {
        state: 'system.settingcenter.portSetUp.list',
        config: {
            url: '/list',
            template: require('./view/portSetUp.html'),
            controller: 'portSetUpCtrl',
        },
    },
    add: {
        state: 'system.settingcenter.portSetUp.add',
        config: {
            url: '/add',
            template: require('./view/add.html'),
            controller: 'addportSetUpCtrl',
            title: '新增模版',
        },
    },
    edit: {
        state: 'system.settingcenter.portSetUp.edit',
        config: {
            url: '/edit/:interfaceId',
            template: require('./view/add.html'),
            controller: 'addportSetUpCtrl',
            title: '编辑模版',
        },
    },
    detail: {
        state: 'system.settingcenter.portSetUp.detail',
        config: {
            url: '/detail./:interfaceId',
            template: require('./view/add.html'),
            controller: 'addportSetUpCtrl',
            title: '模版详情',
        },
    },
}



// WEBPACK FOOTER //
// ./src/app/system/settingcenter/portSetUp/routers.js